import { LoginSocialBarIcons } from './LoginSocialBarIcons';

export default LoginSocialBarIcons;
